import { useEffect } from 'react'
import Datatable from '../../atoms/Datatable/Datatable'
import DatatableRowCart, { DatatableCartCols } from '../DatatableRowCart/DatatableRowCart'
import DataTableRowCreaOfferta, {
  DataTableCreaOffertaCols,
} from '../DataTableRowCreaOfferta/DataTableRowCreaOfferta'
import _ from 'lodash'
import { useSelector } from 'react-redux'

const ArticoliSenzaStampa = ({
  righe,
  salvati = false,
  MoveToMain,
  MoveToLater,
  Delete,
  setOpenModalNota,
  setId,
  setNota,
  setCodice,
  setOpenModalRimuovi,
  setOpenModalQuantita,
  carrelloMain,
  creaOfferta,
}) => {
  const { service_gift } = useSelector((state) => state.servicegift)

  return (
    // Con headings, quindi aggiungo la Datatable intorno
    <Datatable
      cols={
        creaOfferta
          ? creaOfferta?.margineInput
            ? DataTableCreaOffertaCols
            : _.omit(DataTableCreaOffertaCols, [
                creaOfferta?.tipoMarkup === 'sul_totale' ? 'totale_quotazione' : '',
                'margine',
                creaOfferta?.preview
                  ? 'prezzoPezzo'
                  : creaOfferta?.tipoMarkup === 'sul_totale'
                  ? 'prezzoPezzo'
                  : '',
                creaOfferta?.preview
                  ? 'totale'
                  : creaOfferta?.tipoMarkup === 'sul_totale'
                  ? 'totale'
                  : '',
              ])
          : service_gift && !service_gift.personalizzazione
          ? _.omit(DatatableCartCols, ['personalizzazione'])
          : DatatableCartCols
      }
    >
      {righe?.map((item, i) =>
        creaOfferta ? (
          <DataTableRowCreaOfferta
            riga={item}
            rigaId={item?.id}
            tipoMarkup={creaOfferta?.tipoMarkup}
            creaOfferta={creaOfferta}
            margineInput={creaOfferta?.margineInput}
            totaleQuotazione={creaOfferta?.totaleQuotazione}
            preview={creaOfferta?.preview}
            articolo={item.articolo}
            quantita={item.quantita}
            key={item.id}
            even={i % 2 == 0}
          />
        ) : (
          <DatatableRowCart
            carrelloMain={carrelloMain}
            isSalvatoPerDopo={salvati}
            isPersonalizzato={false}
            isPersonizzabile={!item.articolo.escludi_da_listino_di_stampa}
            articolo={item.articolo}
            quantita={item.quantita}
            key={item.id}
            riga={item}
            id={item.id}
            nota={item.nota}
            MoveToLater={!salvati && MoveToLater}
            MoveToMain={MoveToMain}
            Delete={Delete}
            setOpen={setOpenModalNota}
            setId={setId}
            setNota={setNota}
            saveCodice={setCodice}
            setDeleteOpen={setOpenModalRimuovi}
            setOpenModalQuantita={setOpenModalQuantita}
            even={i % 2 == 0}
          />
        )
      )}
    </Datatable>
  )
}

export default ArticoliSenzaStampa
